<div class="admin-kezdo">

  <header class="admin-kezdo__fejlec">
    <h1>{{ koszones }}{{ nev ? ', ' + nev : '' }}!</h1>
    <p>
      <b>Adminisztráció</b><span *ngIf="!sulinform"> · {{ modNev }}</span>
      <span *ngIf="intezmenyNev"> · {{ intezmenyNev }}</span>
    </p>

    <div class="admin-kezdo__szamok" *ngIf="szamKulcsok.length">
      <div class="szam" *ngFor="let k of szamKulcsok">
        <span class="szam__ertek">{{ szamok[k] }}</span>
        <span class="szam__cimke">{{ k }}</span>
      </div>
    </div>

    <div class="admin-kezdo__figyelem" *ngIf="sulinform && munkatanevEltero">
      <ion-icon name="construct-outline"></ion-icon>
      Előkészítés alatt álló tanéven dolgozol – a törzsadat-felületek arra az évre mentenek.
    </div>
  </header>

  <!-- Gyakran használt: a böngészőben számolva (admin-menu.service.ts). -->
  <section class="admin-kezdo__gyakori" *ngIf="gyakori.length">
    <span class="admin-kezdo__gyakori-cim">Gyakran használt</span>
    <button type="button" class="chip" *ngFor="let g of gyakori" (click)="nyit(g.ut)" [title]="g.teruletCim">{{ g.cim }}</button>
  </section>

  <section class="admin-kezdo__terulet" *ngIf="terulet">
    <div class="admin-kezdo__terulet-fej">
      <img [src]="terulet.kep" alt="" width="40" height="40">
      <div>
        <h2>{{ terulet.cim }}</h2>
        <p *ngIf="terulet.leiras">{{ terulet.leiras }}</p>
      </div>
    </div>

    <div class="admin-kezdo__alcsoport" *ngFor="let a of terulet.alcsoportok">
      <h3 *ngIf="a.cim">{{ a.cim }}</h3>
      <div class="admin-kezdo__racs">
        <button type="button" class="csempe" *ngFor="let p of a.pontok" (click)="nyit(p.ut)">
          <span class="csempe__cim">{{ p.cim }}</span>
          <span class="csempe__leiras" *ngIf="p.leiras">{{ p.leiras }}</span>
        </button>
      </div>
    </div>
  </section>

  <p class="admin-kezdo__ures" *ngIf="kesz && !teruletek.length">
    Ebben a modulban nincs számodra elérhető adminisztrációs képernyő.
  </p>
</div>
